module.exports = __webpack_public_path__ + "img/decor-tire-car-320x108.b84f57fd.webp";